export default __webpack_public_path__ + "static/media/step-4-prizes.928c24eb.png";